import { ISaveDraftJobPostPayload } from '../types';
import { PermanentJobsApi } from '../clients';

export const saveDraftJobPost = async (
  id: string,
  payload: ISaveDraftJobPostPayload,
): Promise<void> => {
  await PermanentJobsApi.saveDraftJobPost(id, payload);
};
